'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatShapes = function MdFormatShapes(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.8 21.3h4.4l-2.2-6.5z m5.1 2.1h-5.9l-1.1 3.2h-2.8l5.7-15h2.4l5.6 15h-2.7z m8.7-15h3.4v-3.4h-3.4v3.4z m3.4 26.6v-3.4h-3.4v3.4h3.4z m-6.6-3.4v-3.2h3.2v-16.8h-3.2v-3.2h-16.8v3.2h-3.2v16.8h3.2v3.2h16.8z m-20 3.4v-3.4h-3.4v3.4h3.4z m-3.4-30v3.4h3.4v-3.4h-3.4z m33.4 6.6h-3.4v16.8h3.4v10h-10v-3.4h-16.8v3.4h-10v-10h3.4v-16.8h-3.4v-10h10v3.4h16.8v-3.4h10v10z' })
        )
    );
};

exports.default = MdFormatShapes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-shapes.js
// module id = 2370
// module chunks = 0